import { PropsWithChildren, ComponentProps } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';

type AvailabilityRuleFormHeadingProps = ComponentProps<typeof Heading>;

export const AvailabilityRuleFormHeading = ({
  children,
  ...props
}: PropsWithChildren<AvailabilityRuleFormHeadingProps>) => {
  return (
    <Heading level={3} {...props} css={styles.heading}>
      {children}
    </Heading>
  );
};

const styles = {
  heading: css`
    margin-bottom: ${theme.spacing(2)};
  `,
};
